import React from 'react';
import classNames from 'classnames';
import * as S from './SuppliersProgressBar.styles';
import {ISupplierProgressInformationBarData} from '../../../../../shared/types/aisProfile';
import CTA from '../../../common/CTA/CTA';
const SuppliersProgressBar: React.FC<ISupplierProgressInformationBarData> = (
  data,
): React.ReactElement => {
  const {footer, primaryText, secondaryText, profileCompletionPercentage} = data;
  const {
    data: {styles, ctas},
  } = footer || {};

  return (
    <>
      <S.SupplierProgressListMainWrap completionPercent={profileCompletionPercentage}>
        <div className="suppliersProgressBar">
          <p className="makeFlex spaceBetween appendBottom8 font14 lineHeight20 latoBold">
            <span>{primaryText}</span>
            <span>{secondaryText}</span>
          </p>
          <div className="progressOuter">
            <div className={`progressInner`}></div>
          </div>
        </div>
      </S.SupplierProgressListMainWrap>
      <span
        className={`font14 lineHeight20  verifiedPersuasion  ${classNames(styles?.customClasses)}`}
      >
        {footer?.data?.primaryText}
        {ctas?.length > 0 &&
          ctas.map(({component, data}, idx) => {
            return <CTA component={component} data={data} />;
          })}
      </span>
    </>
  );
};

export default SuppliersProgressBar;
